import { Box,  Typography,  } from '@mui/material';
import React from 'react';
import { getResponsiveHeight, getResponsiveSize } from '../utils/responsive';
import globalStyles from '../global';
// import CardComponent from '../components/EventComponent/CardComponent';
import Footer from '../components/HomeComponent/Footer';
import EventForm from '../components/EventComponent/EventForm';
import EventDetails from '../components/EventComponent/EventDetails';
import LaundryLeaders from '../components/EventComponent/LaundryLeaders';
// import ChanceToMeet from '../components/EventComponent/ChanceToMeet';

const SriLankaEvent = () => {
  
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  return (
    <Box>
      {/* <Banner /> */}
      <Box
        sx={[
          styles.box1,
          {
            backgroundImage: {
              xs: `url(${imageBaseUrl}clearBackgroundImage.png)`,
              md: `url(${imageBaseUrl}clearBackgroundImage.png)`,
            },
          },
        ]}
      >
        <Box sx={styles.contentContainer}>
          <Box sx={styles.leftBox}>
            <Box sx={styles.titleWrapper}>
              <Typography sx={styles.title}>
                Laundry Business Seminar in{' '}
                <Typography sx={styles.titleSpan}>Sri Lanka</Typography>
              </Typography>
            </Box>

            <Box sx={styles.subTitleWrapper}>
              <Typography sx={styles.subTitle}>
                Arunabh Sinha shares his insights on building
              </Typography>
              <Typography sx={styles.subTitleBold}>
                India’s largest Laundry Brand
              </Typography>
            </Box>
          </Box>
          <Box sx={styles.rightBox}>
            <EventForm  seminarPlace='SriLanka'/>
          </Box>
        </Box>
      </Box>
      <EventDetails/>
      <LaundryLeaders/>
      {/* <ChanceToMeet color={globalStyles.colors.army_green} textColor={globalStyles.colors.white}/> */}
      <Footer />
    </Box>
  );
};

const styles = {
  text1: {
    color: globalStyles.colors.army_green,
    fontFamily: ' "Poppins", serif ',
    fontWeight: '700',
    lineHeight: 1.2,
    marginTop: getResponsiveHeight(8),
    marginBottom: getResponsiveHeight(2),
  },
  box1: {
    minHeight: {
      xs: 'auto',
      sm: getResponsiveSize(650),
      md: getResponsiveSize(650),
    },
    width: '100%',
    // py: { xs: 2, sm: 6 },
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // overflow: 'hidden',
    display: 'flex',
      py:{xs:'16px',md:'10px'}
  },
  contentContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' }, // Column on mobile, row on desktop
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  
  },
  leftBox: {
    width: { xs: '90%', md: '70%', lg: '32%' },

  },
  rightBox: {
    paddingX: { xs: getResponsiveSize(2), md: getResponsiveSize(0) }, // Add padding
    boxSizing: 'border-box', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: { xs: '100%', md: '50%', lg: '40%' },
    height: { xs: 'auto', md: getResponsiveSize(500) },
  },
  titleWrapper: {
    width: '100%',
    textAlign: 'center',
    mb: { xs: 2, sm: 3 },
    // pl:{xs:getResponsiveSize(2),sm:getResponsiveSize(8)}
  },

  title: {
    color: '#fff',
    fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    lineHeight: 1,
    textAlign: 'left',
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },
  titleSpan: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    display: 'inline',
    textAlign: 'left',
    color: globalStyles.colors.uclean_gold,
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },
  subTitleWrapper: {
    width: '100%',
    textAlign: 'left',
    mb: { xs: 3, sm: 4 },
  },

  subTitle: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 500,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(20),
      md: getResponsiveSize(24),
    },
    color: globalStyles.colors.white,
  },
  subTitleBold: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(20),
      md: getResponsiveSize(24),
    },
    color: globalStyles.colors.white,
  },
 
};

export default SriLankaEvent;
